module.exports = __webpack_public_path__ + "static/img/product3newmodel.52b74f21.png";